import FactCheckIcon from "@mui/icons-material/FactCheck";
import { nacidRequests } from "api/nacidApi";
import { useNotify } from "react-admin";
import dataProvider from "server/dataProvider";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { Button } from "@mui/material";

// Runs the weekly coverage check on demand. It proves the legal obligation — information at НАЦИД for every
// academic period — is actually being met, which watching flows cannot: a trigger lost before any flow existed
// leaves nothing behind but an unverified coverage row.
const ReconcileCoverageButton = () => {
  const notify = useNotify();

  // No try/catch: ConfirmModal catches, notifies and keeps itself open.
  const handleConfirm = async () => {
    await dataProvider.customRequest(nacidRequests.reconcileCoverage(), null, "POST");

    // The endpoint answers 202 and the run is asynchronous — say "started", never "completed".
    notify("Проверката на покритието е стартирана.", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleConfirm}
      titleContent="Проверка на покритието в НАЦИД"
      message={
        "Всеки непроверен период ще бъде сверен с НАЦИД. Липсващ период създава поток за корекция, " +
        "а разминаване се отбелязва за ръчна намеса и не се коригира автоматично. Проверката се изпълнява " +
        "във фонов режим."
      }
      saveTitle="Стартирай"
      triggerButton={
        <Button
          label="Провери покритието"
          startIcon={<FactCheckIcon />}
        />
      }
    />
  );
};

export default ReconcileCoverageButton;
